import {ajax,getRequestUrl,formatData} from "../request";


export default {
  // 用户信息查询
  // 用户查询 -- 用户列表
  memberList(data, method) {
    return ajax('post', getRequestUrl('/user/memberList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },
  // 用户查询 -- 用户列表
  userDestroyList(data, method) {
    return ajax('post', getRequestUrl('/api/Member/userDestroyList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 用户查询 -- 用户详情
  usersSearch(data, method) {
    return ajax('post', getRequestUrl('/user/findMember'), data, {
      method,
    });
  },
  // 用户查询 -- 成员榜单
  memberRank(data, method) {
    return ajax('post', getRequestUrl('/user/memberRank'), data, {
      method,
    });
  },

  // 用户查询 -- 用户详情-扣除金币
  deductCoin(data, method) {
    return ajax('post', getRequestUrl('/user/deductGolds'), data, {
      method,
    });
  },

  // 用户查询 -- 用户详情-钻石详情
  diamondRecordList(data, method) {
    return ajax('post', getRequestUrl('/api/Member/diamondRecordList'), data, {
      method,
    });
  },


  // 用户查询 -- 用户详情房间是否可认证
  checkAuthenticate(data, method) {
    return ajax('post', getRequestUrl('/api/Member/checkAuthenticate'), data, {
      method,
    });
  },
  // 用户查询 -- 运营备忘
  uidMemoList(data, method) {
    return ajax('post', getRequestUrl('/user/memo/list'), data, {
      method,
    });
  },
  // 用户查询 -- 运营备忘添加
  uidMemoAdd(data, method) {
    return ajax('post', getRequestUrl('/user/memo/add'), data, {
      method,
    });
  },
  // 用户查询 -- 消费详情
  payRecordList(data, method) {
    return ajax('post', getRequestUrl('/api/Member/payRecordList'), data, {
      method,
    });
  },

  // 用户查询 -- 兑换记录
  tobalanceRecord(data, method) {
    return ajax('post', getRequestUrl('/api/Member/tobalanceRecord'), data, {
      method,
    });
  },

  // 用户查询 -- 用户详情-解除绑定
  userUnbind(data, method) {
    return ajax('post', getRequestUrl('/user/unbind'), data, {
      method,
    });
  },

  // 用户查询 -- 设置会员信息
  setMemberInfo(data, method) {
    return ajax('post', getRequestUrl('/user/appRole'), data, {
      method,
    });
  },

  // 用户查询 -- 更多ip
  memberMoreIp(data, method) {
    return ajax('post', getRequestUrl('/user/moreIp'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 用户查询 -- 修改用户信息 //1靓号 2昵称 3头像 4国家-省份 5邮箱 6手机号 7区号 8密码 9性别 10签名 11（修改财富等级）、12（修改魅力等级）
  saveUserInfo(data, method) {
    return ajax('post', getRequestUrl('/user/updateMember'), data, {
      method,
    });
  },

  // 用户查询 -- 修改靓号
  saveUserNo(data, method) {
    return ajax('post', getRequestUrl('/api/Member/saveUserNo'), data, {
      method,
    });
  },

  // 用户查询 -- 修改昵称
  saveNickname(data, method) {
    return ajax('post', getRequestUrl('/api/Member/saveNickname'), data, {
      method,
    });
  },

  // 用户查询 -- 修改头像
  saveAvatar(data, method) {
    return ajax('post', getRequestUrl('/api/Member/saveAvatar'), data, {
      method,
    });
  },

  // 用户查询 -- 封禁广播
  memberBannedBroadcast(data, method) {
    return ajax('post', getRequestUrl('/api/Member/banBroadcast'), data, {
      method,
    });
  },


  // 用户查询 -- 封禁id
  memberBannedId(data, method) {
    return ajax('post', getRequestUrl('/ban/banId'), data, {
      method,
    });
  },


  // 用户查询 -- 保存认证信息
  saveAuthenticateInfo(data, method) {
    return ajax('post', getRequestUrl('/api/Member/saveAuthenticateInfo'), data, {
      method,
    });
  },

  // 用户查询 -- 封禁设备
  memberBannedDevice(data, method) {
    return ajax('post', getRequestUrl('/ban/banDevice'), data, {
      method,
    });
  },
  // 用户查询 -- 批量封禁设备
  batchBanDevice(data, method) {
    return ajax('post', getRequestUrl('/ban/batchBanDevice'), data, {
      method,
    });
  },

  // 用户查询 -- 更新密码
  userSavePassword(data, method) {
    return ajax('post', getRequestUrl('/api/Member/savePassword'), data, {
      method,
    });
  },

  // 用户查询 -- 更新等级
  userSaveLevel(data, method) {
    return ajax('post', getRequestUrl('/api/Member/saveLevel'), data, {
      method,
    });
  },

  // 用户查询 -- 修改会员资金状态
  userFreezeMember(data, method) {
    return ajax('post', getRequestUrl('/ban/freezeMember'), data, {
      method,
    });
  },

  // 用户查询 -- 国家列表
  findCountryList(data, method) {
    return ajax('post', getRequestUrl('/region/country/list'), data, {
      method,
    });
  },

  // 用户查询 -- 更新国家
  userSaveCountry(data, method) {
    return ajax('post', getRequestUrl('/api/Member/saveCountry'), data, {
      method,
    });
  },

  // 用户查询 -- 更新手机号
  userSaveMobile(data, method) {
    return ajax('post', getRequestUrl('/api/Member/saveMobile'), data, {
      method,
    });
  },

  // 用户查询 -- 更新手机号
  userSaveEditRegion(data, method) {
    return ajax('post', getRequestUrl('/api/Member/editRegion'), data, {
      method,
    });
  },
  // 用户查询 -- 修改订阅有效期
  subVipSet(data, method) {
    return ajax('post', getRequestUrl('/api/Member/subVipSet'), data, {
      method,
    });
  },

  // 用户查询 -- 更新邮箱
  userSaveEmail(data, method) {
    return ajax('post', getRequestUrl('/api/Member/saveEmail'), data, {
      method,
    });
  },

  // 用户查询 -- 拉黑IP
  userBlockIp(data, method) {
    return ajax('post', getRequestUrl('/api/Member/blockIp'), data, {
      method,
    });
  },

  // 用户查询 -- 充值明细
  memberRechargeList(data, method) {
    return ajax('post', getRequestUrl('/user/recharge/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 用户查询 -- 代充明细
  memberTransferRechargeList(data, method) {
    return ajax('post', getRequestUrl('/user/agent/transfer'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 用户查询 -- 解禁广播
  memberUnBannedBroadcast(data, method) {
    return ajax('post', getRequestUrl('/api/Member/unbanBroadcast'), data, {
      method,
    });
  },

  // 用户查询 -- 解禁设备
  memberNoBannedDevice(data, method) {
    return ajax('post', getRequestUrl('/ban/banDevice'), data, {
      method,
    });
  },
  // 用户查询 -- 封禁召唤
  gatherBan(data, method) {
    return ajax('post', getRequestUrl('/api/Member/gatherBan'), data, {
      method,
    });
  },
  // 用户查询 -- 解禁召唤
  gatherUnblock(data, method) {
    return ajax('post', getRequestUrl('/api/Member/gatherUnblock'), data, {
      method,
    });
  },

  // 用户查询 -- 解禁id
  memberUnBannedId(data, method) {
    return ajax('post', getRequestUrl('/ban/banId'), data, {
      method,
    });
  },

  // 用户查询 -- 道具列表
  memberFindPropList(data, method) {
    return ajax('post', getRequestUrl('/common/findPropList'), data, {
      method,
    });
  },
  // 用户查询 -- 道具列表-卡券
  memberFindPropListCard(data, method) {
    return ajax('post', getRequestUrl('/common/findCardList'), data, {
      method,
    });
  },
  // 用户查询 -- 道具列表-礼物
  memberFindPropListGift(data, method) {
    return ajax('post', getRequestUrl('/common/findGiftList'), data, {
      method,
    });
  },
  // 用户查询 -- 道具列表-信物
  memberFindPropListKeepsake(data, method) {
    return ajax('post', getRequestUrl('/common/findKeepsakeList'), data, {
      method,
    });
  },

  // 用户查询 -- 新增道具
  memberCreateProp(data, method) {
    return ajax('post', getRequestUrl('/prop/sendProp'), data, {
      method,
    });
  },
  // 用户查询 -- 新增道具-卡券
  memberCreatePropCard(data, method) {
    return ajax('post', getRequestUrl('/prop/sendCard'), data, {
      method,
    });
  },
  // 用户查询 -- 新增道具-礼物
  memberCreatePropGift(data, method) {
    return ajax('post', getRequestUrl('/prop/sendGift'), data, {
      method,
    });
  },
  // 用户查询 -- 新增道具-信物
  memberCreatePropKeepsake(data, method) {
    return ajax('post', getRequestUrl('/prop/sendKeepsake'), data, {
      method,
    });
  },

  // 用户查询 -- 赠送金币
  sendGold(data, method) {
    return ajax('post', getRequestUrl('/assets/sendGold'), data, {
      method,
    });
  },

  // 用户查询 -- 删除用户道具
  memberDeleteHoldProp(data, method) {
    return ajax('post', getRequestUrl('/prop/delete'), data, {
      method,
    });
  },

  // 用户查询--删除用户背包卡券等
  deleteBackpackProp(data, method) {
    return ajax('post', getRequestUrl('/api/Member/deleteBackpackProp'), data, {
      method,
    });
  },

  // 用户查询--明细列表--全部封禁
  allSelectBlockId(data, method) {
    return ajax('post', getRequestUrl('/api/Member/allBlockId'), data, {
      method,
    });
  },

  // 用户查询--明细列表--选择封禁用户
  selectBlockId(data, method) {
    return ajax('post', getRequestUrl('/api/Member/selectBlockId'), data, {
      method,
    });
  },

  // 用户查询 -- 用户封禁操作记录
  memberHistoryList(data, method) {
    return ajax('post', getRequestUrl('/api/Member/serviceHistoryList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 用户查询 -- 特殊cp关系
  specialList(data, method) {
    return ajax('post', getRequestUrl('/api/Member/specialList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 用户管理-用户标签管理列表
  userTagList(data, method) {
    return ajax('post', getRequestUrl('/api/Member/userTagList'), data, {
      method,
    })
  },


  // 用户管理-用户标签 保存 /上下架
  userTagSave(data, method) {
    return ajax('post', getRequestUrl('/api/Member/userTagSave'), data, {
      method,
    })
  },


  // 用户管理-用户标签 保存 /上下架
  userTagIsOn(data, method) {
    return ajax('post', getRequestUrl('/api/Member/userTagIsOn'), data, {
      method,
    })
  },


  // 用户管理-用户标签 保存 /上下架
  actionAdd(data, method) {
    return ajax('post', getRequestUrl('/activity/actionAdd'), data, {
      method,
    })
  },

  // 营收活动 活动奖励 生成活动链接
prizeTemplateUrl(data, method) {
  return ajax('post', getRequestUrl('/api/Activity/prizeTemplateUrl'), data, {
    method,
  })
},

  // 用户管理-身份认证详情
  authenticateInfo(data, method) {
    return ajax('post', getRequestUrl('/api/Member/authenticateInfo'), data, {
      method,
    })
  },

  // 用户管理-个人礼物信息
  detailHoldProp(data, method) {
    return ajax('post', getRequestUrl('/user/props'), data, {
      method,
    })
  },

  // 用户管理-重置资料接口
  resetUserInfo(data, method) {
    return ajax('post', getRequestUrl('/user/resetInfo'), data, {
      method,
    })
  },


  // 用户管理-主播提现买币明细
  familyWithdrawalRrecordList(data, method) {
    return ajax('post', getRequestUrl('/api/Member/familyWithdrawalRrecordList'), data, {
      method,
    })
  },


  // 用户查询 -- CP关系列表
  getCpList(data, method) {
    return ajax('post', getRequestUrl('/user/cp/list'), data, {
      method,
    })
  },

  // 荣誉信函
  addUserLetter(data,method){
    return ajax('post', getRequestUrl('/user/honorLetter/add'), data, {
      method,
    })
  },
  getUserLetterList(data,method){
    return ajax('post', getRequestUrl('/user/honorLetter/list'), data, {
      method,
    })
  },
  delUserLetterList(data,method){
    return ajax('post', getRequestUrl('/user/honorLetter/del'), data, {
      method,
    })
  },
}



// WEBPACK FOOTER //
// ./src/js/https/users.js